import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../../../store/redux-store'
import {
  DISABLE_EDIT_ACTIONS,
  sendEvent as sendEventAction,
  sendMessage as sendMessageAction,
} from '../../../store/modules/webchat'

interface EventPayload {
  name: string
  value?: unknown
}

interface MessagePayload {
  message: string
  [key: string]: unknown
}

export const useStore = () => {
  const dispatch = useDispatch<AppDispatch>()

  const sendEvent = (payload: EventPayload) => {
    dispatch(sendEventAction(payload))
  }

  const sendMessage = (payload: MessagePayload) => {
    dispatch(sendMessageAction(payload))
  }

  const disableEditActions = () => {
    dispatch(DISABLE_EDIT_ACTIONS())
  }

  return {
    sendEvent,
    sendMessage,
    disableEditActions,
  }
}
